import documentsActionTypes from "Areas/Documents/redux/actionTypes";
import documentsSidebarMenuActionTypes from "Areas/Sidebar/Documents/redux/actionTypes";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import omit from "lodash/omit";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        innerObjectsSelectedIds: {},
        readOnlyMode: {},
        taskResultLimit: {}
    }
};
export default createReducer(initialState, {
    [actionTypes.SET_INNER_OBJECTS_SELECTED]: (state, { selected, documentId, documentType }) => {
        let result = state;
        if (!state[NAMESPACE].innerObjectsSelectedIds[documentId])
            result = set(result, `[${NAMESPACE}].innerObjectsSelectedIds[${documentId}]`, {});
        return set(result, `[${NAMESPACE}].innerObjectsSelectedIds[${documentId}][${documentType}]`, selected);
    },
    [actionTypes.SET_READONLY_MODE]: (state, { documentId, readOnlyMode }) => set(state, `[${NAMESPACE}].readOnlyMode[${documentId}]`, readOnlyMode),
    [actionTypes.GET_TASK_RESULT_LIMIT_COMPLETED]: (state, { meta, payload }) => set(state, `[${NAMESPACE}].taskResultLimit[${meta.documentId}]`, payload),
    [actionTypes.SAVE_TASK_RESULT_LIMIT_COMPLETED]: (state, { meta }) => set(state, `[${NAMESPACE}].taskResultLimit[${meta.documentId}]`, meta.taskResultLimit),
    [documentsActionTypes.DELETE_DOCUMENT_COMPLETED]: (state, { meta }) => {
        let result = set(state, `[${NAMESPACE}].innerObjectsSelectedIds`, omit(state[NAMESPACE].innerObjectsSelectedIds, meta.documentId));
        result = set(result, `[${NAMESPACE}].readOnlyMode`, omit(state[NAMESPACE].readOnlyMode, meta.documentId));
        return set(result, `[${NAMESPACE}].taskResultLimit`, omit(state[NAMESPACE].taskResultLimit, meta.documentId));
    },
    [documentsSidebarMenuActionTypes.SET_DOCUMENT_SELECTED]: (state, { documentId, selected }) => {
        if (selected)
            return state;
        let result = set(state, `[${NAMESPACE}].innerObjectsSelectedIds`, omit(state[NAMESPACE].innerObjectsSelectedIds, documentId));
        result = set(result, `[${NAMESPACE}].readOnlyMode`, omit(state[NAMESPACE].readOnlyMode, documentId));
        return set(result, `[${NAMESPACE}].taskResultLimit`, omit(state[NAMESPACE].taskResultLimit, documentId));
    }
});
